import * as general from './general'
import * as routes from './routes'

export const projectFacadeHelper = {
  general,
  routes,
}
